export const ADMIN_MODULE_ROLENAME = [
  {
    Header: "ID",
    accessor: "role_id",
    show: true,
  },

  {
    Header: "ROLE NAME",
    accessor: "role_name",
    show: true,
  },
  {
    Header: "PROJECT NAME",
    accessor: "project_name",
    show: true,
  },
  {
    Header: "Description",
    accessor: "description",
    show: true,
  },
  {
    Header: "UPDATE",
    accessor: "role_edit",
    show: true,
  },
  {
    Header: "DELETE",
    accessor: "role_delete",
    show: true,
  },
];



export const USER_LIST_COLUMNS = [
  {
    Header: "COMPANY NAME",
    accessor: "CompanyName",
    show: true,
  },
  {
    Header: "USERNAME",
    accessor: "LoginId",
    show: true,
  },
  {
    Header: "FIRST NAME",
    accessor: "FirstName",
    show: true,
  },
  {
    Header: "LAST NAME",
    accessor: "LastName",
    show: true,
  },
  {
    Header: "EMAIL",
    accessor: "Email",
    show: true,
  },
  {
    Header: "MOBILE NUMBER",
    accessor: "MobileNo",
    show: true,
  },
  {
    Header: "AGE",
    accessor: "Age",
    show: false,
  },
  {
    Header: "MFA",
    accessor: "IsMFA",
    show: true,
  },
  {
    Header: "MFADays",
    accessor: "MFADays",
    show: true,
  },
];

export const ADMIN_MODULE_ASSIGN_ROLE = [
  {
    Header: "USER MAPPING ID",
    accessor: "RoletoUserMappingId",
    show: false,
  },
  {
    Header: "PROJECT ID",
    accessor: "ProjectId",
    show: false,
  },
  {
    Header: "PROJECT NAME",
    accessor: "ProjectName",
    show: true,
  },
  {
    Header: "ROLE ID",
    accessor: "RoleId",
    show: false,
  },
  {
    Header: "ROLE NAME",
    accessor: "RoleName",
    show: true,
  },
  {
    Header: "USER ID",
    accessor: "UserId",
    show: false,
  },
  {
    Header: "FIRST NAME",
    accessor: "FirstName",
    show: true,
  },
  {
    Header: "LAST NAME",
    accessor: "LastName",
    show: true,
  },
 
];
